/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForSsmData extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForSsmData.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForSsmData>): ProgressDetailsForSsmData {
        let obj = Object.assign(new ProgressDetailsForSsmData(), model);
        ProgressDetailsForSsmData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForSsmData>): ProgressDetailsForSsmData {
        if (!model) return null;
        return ProgressDetailsForSsmData.newInstance(<ProgressDetailsForSsmData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForSsmData) {
        if (!obj) return;

        models.ProgressDetailsForSsmData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForSsmData): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForSsmData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Manual or Automation sync
     */
    sync_type: string;

}
